import { useEffect, useState } from 'react';
import { Button, Icon } from '@mercator-gcp/grout';
import { FlexColumn } from 'components/layout/FlexColumn/FlexColumn';
import { usePresetFilters } from 'hooks/filterToolbar/usePresetFilters';
import {
  useDashboardTriggers,
  useDashboardPastProjectStage,
  useDashboardExcludePastProjectStage,
  useDashboardCompanyStakeholderTypesExclusions,
  useUserStateSelection,
} from 'state/dashboard';
import {
  getRegionFromSelectedState,
  PRESET_FILTERS,
} from 'utils/constants/presetFilters';
import { groupRawToGroup } from 'utils/transforms';

const containerStyle = {
  gap: 'padding_8',
  paddingTop: '6px',
  paddingBottom: '6px',
  paddingLeft: '6px',
};

const PresetFilterMenu = () => {
  const [selectedKey, setSelectedKey] = useState<string | undefined>('');
  const [selectedState] = useUserStateSelection();
  const region = getRegionFromSelectedState(selectedState);
  const [, saveTriggers] = useDashboardTriggers();
  const [, setPastProjectStages] = useDashboardPastProjectStage();
  const [, setExcludePastProjectStages] = useDashboardExcludePastProjectStage();
  const [, setStakeholderExclusions] = useDashboardCompanyStakeholderTypesExclusions();

  const { data, isLoading } = usePresetFilters({
    presetFilterName: selectedKey,
    region,
  });

  const setFilters = () => {
    if (!data?.data) return;
    const converted = groupRawToGroup(data.data as any);
    saveTriggers(converted.triggers || []);
    setPastProjectStages(converted.past_project_stage || []);
    setExcludePastProjectStages(converted.exclude_past_project_stage || false);
    if (converted.company_stakeholder_types_exclusions != null) {
      setStakeholderExclusions(converted.company_stakeholder_types_exclusions);
    } else {
      setStakeholderExclusions('');
    }
  };

  const onClick = (key: string) => {
    if (key !== selectedKey) {
      setSelectedKey(key);
    } else {
      setFilters();
    }
  };

  useEffect(() => {
    if (!isLoading && data) {
      setFilters();
    }
  }, [data, isLoading]);

  useEffect(() => {
    // Reset selected key when selected state (and thus region) changes
    setSelectedKey('');
  }, [selectedState]);

  return (
    <FlexColumn sx={containerStyle}>
      {PRESET_FILTERS.map((preset) => (
        <Button
          key={preset.key}
          variant="secondary"
          onClick={() => onClick(preset.key)}
          isLoading={isLoading && selectedKey === preset.key}
          isDisabled={isLoading && selectedKey !== preset.key}
          startAdornment={<Icon name={Icon.Name.Vector} />}
        >
          {preset.label}
        </Button>
      ))}
    </FlexColumn>
  );
};

export default PresetFilterMenu;
